import './balance.scss';
import { Bank } from "../../uiKit/assets/svg/icons";
import Title from "../../uiKit/Title/Title";

const Balance = ({ balance, title = 'Our Balance' }) => (
    <div
        className='mobileBalance'
    >
        <Bank />
        <div style={{ marginLeft: '16px' }}>
            <Title
                text={balance}
                fontSize={16}
            />
            <Title
                text={title}
                fontWeight={400}
            />
        </div>
    </div>
)

export default Balance;